import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { ExtractionType } from "../../interfaces/doc";
import { DialogProps } from "./useDialogs";

export interface ConfigExtractionQueryDialogProps {
  addLLMQuery: Function;
  addRegexQuery: Function;
  addPredefinedQuery: Function;
  addComputedQuery: Function;
  addAggregateQuery: Function;
}

const ConfigExtractionQueryDialog = ({
  payload,
  open,
  onClose,
}: DialogProps<ConfigExtractionQueryDialogProps>) => {
  const handleQueryClick = (value: ExtractionType) => {
    if (value === ExtractionType.LLM) {
      payload.addLLMQuery();
    } else if (value === ExtractionType.REGEX) {
      payload.addRegexQuery();
    } else if (value === ExtractionType.PREDEFINED) {
      payload.addPredefinedQuery();
    } else if (value === ExtractionType.COMPUTED) {
      payload.addComputedQuery();
    } else if (value === ExtractionType.AGGREGATE) {
      payload.addAggregateQuery();
    }
    onClose();
  };

  return (
    <Dialog onClose={() => onClose()} open={open}>
      <DialogTitle>Choisissez un type d'extraction</DialogTitle>
      <DialogContent>
        <List>
          {Object.values(ExtractionType).map((type) => (
            <ListItem disablePadding key={type}>
              <ListItemButton onClick={() => handleQueryClick(type)}>
                <ListItemText primary={type} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()}>Annuler</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfigExtractionQueryDialog;
